<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <div class="tercero-table-block mt-4" v-if="listTipoTasa?.length > 0">
            <CorporateDataTable
                :items="listTipoTasaFormat"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :labels="tableLabels"
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
                @row-clicked="(item) => editTipoTasa(item.id)"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="createTipoTasa()">
                        {{ labels.addTipoTasa }}
                    </b-button>
                </template>
            </CorporateDataTable>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modalCrear="showTipoTasa" @creado="actualizarTabla" @cierraModal="closeModal"></Crear>
        <Editar :modalEditar="showEditTipoTasa" @actualizado="actualizarTabla" @eliminado="actualizarTabla" :infoTipoTasa="dataTipoTasa" @cierraModal="closeModal"></Editar>
    </div>
</template>

<script>
import TipoTasas from '../../../services/TipoTasas';
import CorporateDataTable from '../../utils/CorporateDataTable.vue'
import Crear from './Crear'; 
import Editar from './Editar'; 

export default {
    name: 'TipoTasas',
    components:{Crear,Editar,CorporateDataTable},
    data:() => ({
        listTipoTasa : [],
        showTipoTasa : false,
        showEditTipoTasa : false,
        dataTipoTasa : [],
        perPage: 10,
        currentPage: 1,
        fields: [
            { key: 'tipo_tasa', label: 'Código', sortable: false },
            { key: 'descripcion', label: 'Descripción', sortable: false },
            { key: 'frecuencia', label: 'Frecuencia', sortable: false },
            { key: 'modalidad', label: 'Modalidad', sortable: false },
        ],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Tipo tasas',
                    codigo : "Código",
                    descripcion : "Descripción",
                    frecuencia : "Frecuencia",
                    modalidad : "Modalidad",
                    noRow : "No hay registros",
                    addTipoTasa : "Añadir tipo tasa",
                    filterCodigo : "Filtrar código...",
                    filterDescripcion : "Filtrar descripción...",
                    filterFrecuencia : "Filtrar frecuencia...",
                    filterModalidad : "Filtrar modalidad..."
                }
            }else{
                return {
                    title : 'Rate type',
                    codigo : "Code",
                    descripcion : "Description",
                    frecuencia : "Frecuency",
                    modalidad : "Type",
                    noRow : "There are not records",
                    addTipoTasa : "Add fee type",
                    filterCodigo : "Filter code...",
                    filterDescripcion : "Filter description...",
                    filterFrecuencia : "Filter frequency...",
                    filterModalidad : "Filter by mode..."
                }
            }
        },
        listTipoTasaFormat() {
            return this.listTipoTasa.map(item => ({
                ...item,
                modalidad:
                item.modalidad === 'V'
                ? 'Vencida'
                : item.modalidad === 'F'
                ? 'Fija'
                : item.modalidad === 'A'
                ? 'Anticipada'
                : item.modalidad
            }));
        },
        allFields(){
            return [
                { key: 'tipo_tasa', label: this.labels.codigo, sortable: true, thClass: 'text-center', tdClass: 'text-end' },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
                { key: 'frecuencia', label: this.labels.frecuencia, sortable: true, thClass: 'text-center', tdClass: 'text-end' },
                { key: 'modalidad', label: this.labels.modalidad, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'tipo_tasa', type: 'text', placeholder: this.labels.filterCodigo },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescripcion },
                { key: 'frecuencia', type: 'text', placeholder: this.labels.filterFrecuencia },
                { key: 'modalidad', type: 'text', placeholder: this.labels.filterModalidad },
            ]
        },
    },
    methods:{
        goBack() {
            this.$router.back()
        },
        createTipoTasa(){
            this.showTipoTasa = true 
        },
        editTipoTasa(id){
            // console.log(id); 
            TipoTasas.getTipoTasaById(id) 
            .then((res) => {
                this.dataTipoTasa = res.data.tipoTasa
                this.showEditTipoTasa = true 
            })
            .catch((err) => { console.log(err) }) 
        },
        closeModal(valor){
            this.showTipoTasa = valor 
            this.showEditTipoTasa = valor 
        },
        actualizarTabla(){
            TipoTasas.getAllTipoTasas() 
            .then((res) => { 
                // console.log(res.data.listTipoTasas); 
                this.listTipoTasa = res.data.listTipoTasas 
            })
            .catch((err) => { console.log(err) }) 
        }
    },
    mounted(){
        TipoTasas.getAllTipoTasas() 
        .then((res) => { 
            // console.log(res.data.listTipoTasas); 
            this.listTipoTasa = res.data.listTipoTasas 
        })
        .catch((err) => { console.log(err) }) 
    }
}
</script>

<style>

</style>
